module.exports = __webpack_public_path__ + "img/5.e6f40dab.png";